var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "container-fluid railway-main-dashboard-container",
      style: _vm.containerStyles,
    },
    [
      _vm.loading ? [_c("div", { staticClass: "loader-round" })] : _vm._e(),
      [
        _c(
          "el-form",
          {
            staticClass: "pt-4 p-3 text-center",
            staticStyle: { height: "76px" },
            attrs: {
              "label-position": "top",
              "label-width": "8em",
              inline: true,
              size: "small",
            },
          },
          [
            _c(
              "el-form-item",
              {
                staticStyle: {
                  position: "absolute",
                  left: "1rem",
                  "margin-bottom": "1rem",
                },
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", filterable: "" },
                    on: { change: _vm.handlePlanIdChange },
                    model: {
                      value: _vm.planId,
                      callback: function ($$v) {
                        _vm.planId = $$v
                      },
                      expression: "planId",
                    },
                  },
                  _vm._l(_vm.planIds, function (planId) {
                    return _c("el-option", {
                      key: planId,
                      attrs: { label: planId, value: planId },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.planId
              ? _c("el-form-item", [
                  _c("h1", { staticClass: "m-0" }, [
                    _vm._v(
                      _vm._s(_vm.$t("planning.route")) +
                        " [" +
                        _vm._s(_vm.planId.split("-")[0]) +
                        "] > [" +
                        _vm._s(_vm.planId.split("-")[1]) +
                        "]"
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("location-timeline", {
          staticStyle: { "min-height": "calc(100vh - 76px)" },
          attrs: { orderData: _vm.orderData, orderInfo: _vm.orderInfo },
        }),
        _c("countdown", {
          ref: "countdown",
          attrs: { defaultRefreshTime: _vm.refreshTime },
          on: { onCountdownZero: _vm.handleCountdownZero },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }